export default {
  area: "威海市智慧养老",
  objectName: "",
  //url
  // hostUrl : 'http://cuiyun.dexian.ren/',
  hostUrl: 'https://wh.anluoyun.cn',
  apiHttpsUrl: 'https://wh.anluoyun.cn/prod-api',
  apiRequestUrl: 'https://wh.anluoyun.cn/prod-api',
  apiUploadUrl: 'https://wh.anluoyun.cn/prod-api/upload/uploadImage',
  apiUploadFiles: 'https://wh.anluoyun.cn/prod-api/upload/uploadImage',
  apiRequestUrlOrgan: 'https://whso.anluoyun.cn/prod-api/So/',
}
